import { Fragment } from "react";
import { Link } from "react-router-dom";
import PriceTag from "../../assets/common/PriceTag.svg";
import Image from "../../components/general/Image";
import DummyProfile from "../../assets/common/DummyProfile.jpg";
import Button from "../../components/general/Button";

const OverlayedDeveloperCard = ({ onClick }) => {
    return (
        <Fragment>
            <div className="bg-[#292929] rounded-[10px] relative overflow-hidden">
                {
                    <div className="relative">
                        <Image className="absolute top-[20px] w-[95px] h-[50px] right-0" src={PriceTag} alt="price-tag" />

                        <div className="relative z-1 top-[20px] pr-[10px] flex flex-col justify-end items-end">
                            <span className="font-bold text-[18px] text-black"> $35 </span>
                            <span className="block">Per Hour</span>
                        </div>
                    </div>
                }
                <div className="-mt-[20px]">
                    <div className="p-[20px]">
                        <div className="flex items-center justify-center">
                            <figure className="w-[125px] h-[125px] ">
                                <Image className="w-full h-full object-cover rounded-[6px]" src={DummyProfile} alt="" />
                            </figure>
                        </div>
                        <div className="font-semibold text-[22px] mt-[20px] flex justify-center items-center gap-[10px]">
                            <span>
                                John
                            </span>
                        </div>
                        <div className="text-center text-[#D7D7D7] font-extralight">Full Stack Developer</div>
                    </div>
                    <div className="flex justify-between items-center border-y border-[#333333] py-[10px]">
                        <div className="w-[50%] border-r border-[#333333]">
                            <p className="text-center text-[14px] text-[#EFF1F6]">Experience</p>
                            <p className="text-center font-semibold text-primary-color">5 years</p>
                        </div>
                        <div className="w-[50%]">
                            <p className="text-center text-[14px] text-[#EFF1F6]">Availability</p>
                            <p className="text-center font-semibold text-primary-color">Available now</p>
                        </div>
                    </div>
                    <div className="">
                        <Link to={`#`} className="flex justify-between px-[20px] py-[10px]">
                            <span>View Full profile</span>
                            <i className="fa-solid fa-arrow-up-right text-primary-color" />
                        </Link>
                    </div>
                </div>
                <div
                    className="absolute inset-0 flex flex-col items-center justify-center z-10"
                    style={{
                        background: "linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.95))"
                    }}
                >
                    <div className="text-center mb-[15px]">
                        <span className="block uppercase font-bold text-[20px]"> View More </span>
                        <span className="block uppercase font-normal text-[20px]"> Profiles </span>
                    </div>

                    <Button onClick={onClick} className="bg-primary-color text-black font-semibold px-6 py-3 rounded-lg shadow-lg text-lg">
                        Register Now
                    </Button>
                </div>
            </div>
        </Fragment>
    );
};

export default OverlayedDeveloperCard